// extracted by mini-css-extract-plugin
export default {"tableRow":"violationList_tableRow__M19Le","tableCell":"violationList_tableCell__G7M-D"};